export default [
    '3M',
    '6M',
    '1Y',
    '2Y',
    '5Y',
    '10Y'
];
